/**
 * useIsMobile — détecte si le viewport est en taille mobile (< 768px).
 *
 * Utilisé pour simplifier la version téléphone des configurateurs :
 * - Forcer une seule scène (bardage blanc) pour ne pas surcharger l'écran
 * - Masquer le sélecteur de scène (pas pratique au doigt)
 * - Afficher un message invitant à utiliser un ordinateur pour le confort
 *
 * Breakpoint aligné sur Tailwind `md` (768px).
 * Met à jour automatiquement lors du redimensionnement / rotation d'écran.
 */
import { useEffect, useState } from "react";

const MOBILE_MAX_WIDTH = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth < MOBILE_MAX_WIDTH;
  });

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const mql = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH - 1}px)`);
    const handler = (e) => setIsMobile(e.matches);
    // matchMedia.addEventListener n'existe pas sur certains Safari anciens
    if (mql.addEventListener) {
      mql.addEventListener("change", handler);
      return () => mql.removeEventListener("change", handler);
    }
    mql.addListener(handler);
    return () => mql.removeListener(handler);
  }, []);

  return isMobile;
}
